<template>
	<div class="main_header_phone">
		<div class="logo_layout_phone">
			WEIZHIYI
		</div>
		<!-- <div class="jump_to_oa_btn_phone" @click="jump_to_oa"></div> -->
		<div class="menu_btn_phone" @click="show_phone_menu"></div>
		<div class="phone_menu_layout">
			<div class="menu_phone_item" @click="click_one_menu_phone('page1')">
				首页
				<div class="menu_phone_item_cion">
					>
				</div>
			</div>
			<div class="menu_phone_item" @click="click_one_menu_phone('page2')">
				产品中心
				<div class="menu_phone_item_cion">
					>
				</div>
			</div>
			<div class="menu_phone_item" @click="click_one_menu_phone('page7')">
				行业应用
				<div class="menu_phone_item_cion">
					>
				</div>
			</div>
			<div class="menu_phone_item" @click="click_one_menu_phone('page3')">
				项目案例
				<div class="menu_phone_item_cion">
					>
				</div>
			</div>
			<div class="menu_phone_item" @click="click_one_menu_phone('page5')">
				关于我们
				<div class="menu_phone_item_cion">
					>
				</div>
			</div>
			<div class="menu_phone_item" @click="click_one_menu_phone('page6')">
				联系方式
				<div class="menu_phone_item_cion">
					>
				</div>
			</div>
		</div>
	</div>
	<div class="main_header">
		<div class="main_header_layout">
			<div class="main_header_left">
				WEIZHIYI
			</div>
			<div class="show_phont_layout">
				<div class="show_phont_icon">

				</div>
				<div class="show_phont_text">
					服务热线：
				</div>
				<div class="show_phont_val">
					15927666885
				</div>
				<div class="jump_to_oa_btn" @click="jump_to_oa">
					<!-- OA -->
				</div>
			</div>
			<div class="main_header_right">

				<el-menu :default-active="main_activeIndex" ref="menu" class="menu_lyout" mode="horizontal"
					text-color="#000000" active-text-color="#B72024" @select="select_main_menu" :popper-offset="10"
					router :ellipsis="false">

					<el-menu-item index="index" id="page1">首页</el-menu-item>
					<el-menu-item index="product_center" id="page2" class="menu_item_1">产品中心</el-menu-item>
					<div class="header_sub_1">
						<div class="header_sub_item">
							<div class="header_sub_item_title" @click="click_page2_show_menu(1)">
								智能设备
							</div>
							<div class="header_sub_item_list_1">
								<div class="header_sub_item_list_title">
									智能设备
								</div>
								<div class="header_sub_item_list_item" v-for="item in product_list_data_1"
									@click="show_one_product('1_' + item.id)">
									{{ item.title }}
								</div>
								<div style="height: 30px;">

								</div>
							</div>
						</div>
						<div class="header_sub_item">

							<div class="header_sub_item_title" @click="click_page2_show_menu(2)">
								软件系统
							</div>
							<div class="header_sub_item_list_2">
								<div class="header_sub_item_list_title">
									软件系统
								</div>
								<div class="header_sub_item_list_item" v-for="item in product_list_data_2"
									@click="show_one_product('2_' + item.id)">
									{{ item.title }}
								</div>
								<div style="height: 30px;">

								</div>
							</div>
						</div>
						<div class="header_sub_item">
							<div class="header_sub_item_title" @click="click_page2_show_menu(3)">
								软件定制
							</div>
							<div class="header_sub_item_list_3">
								<div class="header_sub_item_list_title">
									软件定制
								</div>
								<div class="header_sub_item_list_item" v-for="item in api_list_data"
									@click="click_one_api_btn(item)">
									{{ item.title }}
								</div>
								<div style="height: 30px;">

								</div>
							</div>
						</div>
					</div>


					<el-menu-item index="project_case" id="page3" class="menu_item_2">项目案例</el-menu-item>
					<div class="header_sub_2">
						<div class="header_sub_item" @click="show_one_product('4_' + item.id)"
							v-for="item in product_list_data_3">
							<!-- AI识别预警系统 -->
							{{ item.title }}
						</div>
						<!-- 									<div class="header_sub_item" @click="show_one_product('4_2')">
										车辆智能管理系统
									</div>
									<div class="header_sub_item" @click="show_one_product('4_3')">
										智能巡检机器人
									</div> -->
					</div>
					<el-menu-item index="industry_applications" id="page7" class="menu_item_2">行业应用</el-menu-item>
					<!-- 								<div class="header_sub_3">
									<div class="header_sub_item" @click="show_one_product('5_'+item.id)" v-for="item in product_list_data_4">
										{{item.title}}
									</div>
								</div> -->
					<!-- 				    <el-sub-menu index="page3"  id="sub-menu">
							      <template #title >软件产品</template>
<el-menu-item index="page3">产品1</el-menu-item>
<el-menu-item index="page4">产品2</el-menu-item>
<template #title>产品4</template>
<el-menu-item index="3-4-1">...</el-menu-item>
<el-menu-item index="3-4-2">...</el-menu-item>
<el-menu-item index="3-4-3">...</el-menu-item>
</el-sub-menu>
</el-sub-menu> -->
					<el-menu-item index="about_us" id="page5">关于我们</el-menu-item>
					<el-menu-item index="contact_information" id="page6">联系方式</el-menu-item>

					<!-- 								<div class="header_sub_3">
								
								</div> -->


				</el-menu>

			</div>

		</div>


	</div>

	<a href="#page2_section1" id="page2_show_menu_item_1" style="visibility: hidden;"></a>
	<a href="#page2_section2" id="page2_show_menu_item_2" style="visibility: hidden;"></a>
	<a href="#page2_section3" id="page2_show_menu_item_3" style="visibility: hidden;"></a>


</template>

<script>
export default {
	name: "Header",
	data() {
		return {
			before_header_isShow: false,
			window_width: 0,
			sys_setting_isShow: false,
			ttt: {},
			main_activeIndex: "index",
			api_list_data: [],
			product_list_data_1: [],
			product_list_data_2: [],
			product_list_data_3: [],
			product_list_data_4: [],
			phone_menu_is_show: false,
		}

	},
	mounted() {
		// document.documentElement.style.setProperty('menu_btn_color_1', 'red');

		this.api_list_data = this.$GLOBAL.api_list_data
		this.product_list_data_1 = this.$GLOBAL.product_list_data_1
		this.product_list_data_2 = this.$GLOBAL.product_list_data_2
		this.product_list_data_3 = this.$GLOBAL.product_list_data_3
		this.product_list_data_4 = this.$GLOBAL.product_list_data_4

		this.main_activeIndex = window.localStorage.getItem("main_path")
		if (!this.main_activeIndex) {
			this.main_activeIndex = "index"
		}
		// this.main_activeIndex = "page3"
	},
	methods: {
		jump_to_oa() {
			window.open('https://oa.doeasyit.com', '_blank');
			// window.open('https://oa.doeasyit.com', '_self');

		},
		click_one_api_btn(item) {
			console.log(item)
			if (item.show_style.indexOf("AI") != -1) {
				this.$router.push("/main/" + item.show_style)
			} else {
				let item_id = item.id

				window.localStorage.setItem("show_id", item_id);
				// this.$router.push("/main/page_api_1")
				this.$router.push({ path: '/main/page_api_1', query: { key: item_id } });
				// console.log(window.location.href)
				// 使用window.location对象刷新页面
				// window.location = window.location;
			}


		},
		show_one_product(id) {
			window.localStorage.setItem("sub_path", id);
			window.localStorage.setItem("main_path", "show_product");
			// this.$router.push("/main/show_product")
			this.$router.push({ path: '/main/show_product', query: { key: id } });

			// console.log(id)
		},
		click_page2_show_menu(index) {
			let now_path = window.localStorage.getItem("main_path")
			// console.log(now_path)
			// console.log(this.$route.path)

			//针对其他页面直接点击的情况
			if (now_path != "page2") {
				if (now_path.indexOf("page") != -1) {
					document.getElementById(now_path).className = "el-menu-item"
				}
				this.$router.push("/main/product_center")
				window.localStorage.setItem("main_path", "page2");
				document.getElementById("page2").className = "el-menu-item is-active"


				// this.$router.push("/main/"+path)
			}

			// 已经在sub子页面
			if (this.$route.path.indexOf("show_product") != -1 || this.$route.path.indexOf("page_api_1") != -1 || this.$route.path.indexOf("AI") != -1) {
				this.$router.push("/main/product_center")
			}
			setTimeout(function () {
				document.getElementById("page2_show_menu_item_" + index).click();
			}, 100)

		},
		click_page3() {
			document.getElementsByClassName("el-menu-item")[4].style.color = "#ffd04b"
			this.main_activeIndex = "index"
			this.$router.push("/main/project_case")
			this.main_activeIndex = "project_case"
			document.getElementById("sub-menu").style.borderBottom = "2px solid #ffd04b !important;"
			this.$refs.menu.open("page3")
		},
		select_main_menu(val) {
			window.localStorage.setItem("main_path", val);

			document.getElementById("page1").className = "el-menu-item"
			document.getElementById("page2").className = "el-menu-item"
			document.getElementById("page3").className = "el-menu-item"
			document.getElementById("page5").className = "el-menu-item"
			document.getElementById("page6").className = "el-menu-item"
			document.getElementById("page7").className = "el-menu-item"
			if (val == "index") {
				val = "page1"
			}
			if (val == "product_center") {
				val = "page2"
			}
			if (val == "project_case") {
				val = "page3"
			}
			if (val == "about_us") {
				val = "page5"
			}
			if (val == "contact_information") {
				val = "page6"
			}
			if (val == "industry_applications") {
				val = "page7"
			}

			document.getElementById(val).className = "el-menu-item is-active"
		},
		// select_menu(index){
		// 	switch(index){
		// 		case 1:
		// 			this.$router.push("/main/page1")//跳转
		// 			break
		// 		case 2:
		// 			this.$router.push("/main/page2")//跳转
		// 			break
		// 		case 3:
		// 			this.$router.push("/main/page3")//跳转
		// 			break
		// 		case 4:
		// 			this.$router.push("/main/page4")//跳转
		// 			break
		// 		case 5:
		// 			this.$router.push("/main/page5")//跳转
		// 			break
		// 		case 6:
		// 			this.$router.push("/main/page6")//跳转
		// 			break
		// 		case 7:
		// 			this.sys_setting_isShow = true
		// 			if(this.window_width < 1550){
		// 				document.getElementById("before_header").style.height = 'calc(100vh - 80px - 5px)'
		// 				document.getElementById("before_header").style.marginTop = '0px'
		// 			}
		// 			break
		// 	}
		// 	if(!this.sys_setting_isShow){
		// 		this.before_header_isShow = true
		// 		this.header_title_content_onclick()
		// 	}
		// },
		header_title_content_onclick() {
			// console.log("before_header_isShow-----------"+this.before_header_isShow)
			// console.log("sys_setting_isShow-------------"+this.sys_setting_isShow)
			// 获取当前屏幕宽度
			let window_width = document.documentElement.offsetWidth
			this.window_width = window_width
			// 判断页面是否下滑
			if (!this.before_header_isShow) {	// 页面未下滑
				this.before_header_isShow = true
				if (window_width < 1550) {	// 屏幕宽度小于1550px
					// 只显示菜单按钮
					document.getElementById("before_header").style.height = '160px'
					document.getElementById("before_header").style.marginTop = '0px'
					this.sys_setting_isShow = false
				} else {
					// 直接显示系统设置页面
					document.getElementById("before_header").style.height = 'calc(100vh - 80px - 10px)'
					document.getElementById("before_header").style.marginTop = '0px'
					this.sys_setting_isShow = true
				}
			} else {	// 菜单以下滑
				this.before_header_isShow = false
				if (window_width < 1550) {	// 屏幕宽度小于1550px		
					// // 判断当前是菜单按钮页面还是系统设置页面
					if (this.sys_setting_isShow) {
						document.getElementById("before_header").style.height = 'calc(100vh - 80px - 5px)'
						document.getElementById("before_header").style.marginTop = 'calc((-100vh + 80px + 5px))'
						// this.sys_setting_isShow = false
					} else {
						document.getElementById("before_header").style.marginTop = '-160px'
					}
					// this.sys_setting_isShow = false

				} else {
					document.getElementById("before_header").style.height = 'calc(100vh - 80px - 10px)'
					document.getElementById("before_header").style.marginTop = 'calc((-100vh + 80px + 10px))'
				}

			}

			// console.log("before_header_isShow-----------"+this.before_header_isShow)
			// console.log("sys_setting_isShow-------------"+this.sys_setting_isShow)
		},
		show_phone_menu() {
			let phone_menu_is_show = window.localStorage.getItem("phone_menu")
			// console.log(phone_menu_is_show)
			if (phone_menu_is_show == "false") {
				window.localStorage.setItem("phone_menu", true)
				document.getElementsByClassName("phone_menu_layout")[0].style.height = "265px";
				document.getElementsByClassName("menu_btn_phone")[0].style.transform = "rotate(180deg)";
			} else {
				window.localStorage.setItem("phone_menu", false)
				document.getElementsByClassName("phone_menu_layout")[0].style.height = "0px";
				document.getElementsByClassName("menu_btn_phone")[0].style.transform = "rotate(0deg)";
			}

		},
		click_one_menu_phone(id) {

			let phone_menu_is_show = window.localStorage.getItem("phone_menu")
			if (phone_menu_is_show == "true") {
				window.localStorage.setItem("phone_menu", false)
				document.getElementsByClassName("phone_menu_layout")[0].style.height = "0px";
				document.getElementsByClassName("menu_btn_phone")[0].style.transform = "rotate(0deg)";
			}

			let new_route = ""
			if (id == "page1") {
				new_route = "index"
			} else if (id == "page2") {
				new_route = "product_center"
			} else if (id == "page3") {
				new_route = "project_case"
			} else if (id == "page5") {
				new_route = "about_us"
			} else if (id == "page6") {
				new_route = "contact_information"
			} else if (id == "page7") {
				new_route = "industry_applications"
			}

			this.$GLOBAL.methods.init_header_menu(id)
			window.localStorage.setItem("main_path", id);
			this.$router.push("/main/" + new_route)
		},
	}
}
</script>

<style>
.jump_to_oa_btn {
	width: 45px;
	height: 45px;
	background: url(../assets/img/oa.png) no-repeat;
	background-size: 100% 100%;
	margin-top: 18px;
	margin-left: -55px;
}

.jump_to_oa_btn:hover {
	cursor: pointer;
}

.jump_to_oa_btn_phone {
	width: 45px;
	height: 45px;
	background: url(../assets/img/oa.png) no-repeat;
	background-size: 100% 100%;
	margin-top: 7px;
	/* margin-left: -200px; */
	position: absolute;
	right: 65px;
}
</style>